import { render, staticRenderFns } from "./App.vue?vue&type=template&id=29d12746&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/blau-weiss-buchholz/wp-content/plugins/arv-integration-italicbold/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29d12746')) {
      api.createRecord('29d12746', component.options)
    } else {
      api.reload('29d12746', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=29d12746&", function () {
      api.rerender('29d12746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/dev/vue/App.vue"
export default component.exports